import {Loading, TextRegular} from '@hm/fundamental'
import React from 'react'
import {useTranslation} from 'react-i18next'

import type {FeatureCatalogItem} from '../../../api/types/featuresMenu'

import {FeatureStoreRow} from './FeatureStoreRow'

interface FeatureStoreContentProps {
  isLoading: boolean
  features: FeatureCatalogItem[]
  addedFeatureIds: Set<number>
  onAddFeature: (feature: FeatureCatalogItem) => void
}

export const FeatureStoreContent: React.FC<FeatureStoreContentProps> = React.memo(
  ({isLoading, features, addedFeatureIds, onAddFeature}) => {
    const {t} = useTranslation()

    if (isLoading) {
      return (
        <div className="flex h-full items-center justify-center" data-cy="feature_store_loader">
          <Loading size="large" />
        </div>
      )
    }

    if (features.length === 0) {
      return (
        <div className="flex h-full items-center justify-center">
          <TextRegular data-cy="feature_store_empty">{t('suite.featureStore.empty')}</TextRegular>
        </div>
      )
    }

    return (
      <div className="flex flex-col gap-3" data-cy="feature_store_list">
        {features.map((feature) => (
          <FeatureStoreRow
            key={feature.id}
            feature={feature}
            isAdded={addedFeatureIds.has(feature.id)}
            onAddFeature={onAddFeature}
          />
        ))}
      </div>
    )
  }
)

FeatureStoreContent.displayName = 'FeatureStoreContent'
